import { render, staticRenderFns } from "./cModalMonitoreo.vue?vue&type=template&id=08ee24ac"
import script from "./cModalMonitoreo.vue?vue&type=script&lang=js"
export * from "./cModalMonitoreo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports